module.exports = __webpack_public_path__ + "static/media/bulb_once.1f47c874.gif";